import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, finalize, lastValueFrom, of, share, tap } from 'rxjs';
import { cloneData, isEmptyObj } from 'src/app/helper/class/utilityHelper';
import { ResponseData } from 'src/app/helper/interface/response';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DataManagementService {
  initCallTbl: string[] = ['zone', 'region', 'branch', 'trust'];
  maplocalData: any = {};
  constructor(private http: HttpClient) {}
  cachedObservable: any = {};
  cache: any = {};
  // getFullData(
  //   tbl: string,
  //   cond: any = '',
  //   isFull = false,
  //   lazy = {},
  //   forceTocall: boolean = false
  // ) {
  //   const tbl_ext = `/` + JSON.stringify(cond);
  //   //const lasyP = isEmptyObj(lazy) ? '' : '/' + JSON.stringify(lazy);
  //   if (isFull) {
  //     return lastValueFrom(
  //       this.http.post(`${this.getApi(tbl)}/getPage/${tbl}${tbl_ext}`, lazy)
  //     );
  //   } else {
  //     let observable: Observable<any>;
  //     const s = tbl + tbl_ext;
  //     if (forceTocall && this.cache[s]) {
  //       delete this.cache[s];
  //     }
  //     if (this.cache[s]) {
  //       observable = of(cloneData(this.cache[s]));
  //     } else if (this.cachedObservable[s]) {
  //       observable = this.cachedObservable[s];
  //     } else {
  //       this.cachedObservable[s] = this.http
  //         .get(`${this.getApi(tbl)}/get/${tbl}${tbl_ext}`)
  //         .pipe(
  //           tap((res: ResponseData) => {
  //             if (res.statusCode == 200) {
  //               this.cache[s] = cloneData(res);
  //             }
  //           }),
  //           share(),
  //           finalize(() => (this.cachedObservable[s] = null))
  //         );
  //       observable = this.cachedObservable[s];
  //     }
  //     // console.log('<-------Size of cache ---------->', this.cache)
  //     return lastValueFrom(observable);
  //   }
  // }

  getFullData(
  tbl: string,
  cond: any = '',
  isFull = false,
  lazy = {},
  forceTocall: boolean = false
) {
  const tbl_ext = this.buildCondPath(cond);
  console.log('tbal ext ',cond)
  if (isFull) {
    return lastValueFrom(
      this.http.post(`${this.getApi(tbl)}/getPage/${tbl}${tbl_ext}`, lazy)
    );
  } else {
    let observable: Observable<any>;
    const s = tbl + tbl_ext;

    if (forceTocall && this.cache[s]) {
      delete this.cache[s];
    }

    if (this.cache[s]) {
      observable = of(cloneData(this.cache[s]));
    } else if (this.cachedObservable[s]) {
      observable = this.cachedObservable[s];
    } else {
      this.cachedObservable[s] = this.http
        .get(`${this.getApi(tbl)}/get/${tbl}${tbl_ext}`)
        .pipe(
          tap((res: ResponseData) => {
            if (res.statusCode == 200) {
              this.cache[s] = cloneData(res);
            }
          }),
          share(),
          finalize(() => (this.cachedObservable[s] = null))
        );

      observable = this.cachedObservable[s];
    }

    return lastValueFrom(observable);
  }
}

buildCondPath(cond: any): string {
  if (cond === null || cond === undefined || cond === '' || (Array.isArray(cond) && cond.length == 0)) {
    return '';
  }
  // single value
  if (!Array.isArray(cond)) {
    return '/' + cond;
  }

  // array
  return cond
    .map((v) => {
      if (Array.isArray(v)) {
        return v.join(',');
      }
      return v;
    })
    .join('/')
    .replace(/^/, '/');
}

  apiCall(url, apiName, forceToCall = false, method = 'get') {
    let observable: Observable<any>;
    const s = apiName;
    if (this.cache[s] && forceToCall) {
      delete this.cache[s];
    }
    if (this.cache[s]) {
      observable = of(cloneData(this.cache[s]));
    } else if (this.cachedObservable[s]) {
      observable = this.cachedObservable[s];
    } else {
      this.cachedObservable[s] = this.http[method](`${url}`).pipe(
        tap((res: ResponseData) => {
          if (res.statusCode == 200) {
            this.cache[s] = cloneData(res);
          }
        }),
        share(),
        finalize(() => (this.cachedObservable[s] = null))
      );
      observable = this.cachedObservable[s];
    }
    return lastValueFrom(observable);
  }

  getApi(tbl: string) {
    return '';
    // return `${
    //   this.payrollTbl.includes(tbl)
    //     ? '/' + environment.payrollUrl
    //     : this.processTbl.includes(tbl)
    //     ? '/' + environment.processApiUrl
    //     : ''
    // }`;
  }
}

function memorySizeOf(obj) {
  var bytes = 0;

  function sizeOf(obj) {
    if (obj !== null && obj !== undefined) {
      switch (typeof obj) {
        case 'number':
          bytes += 8;
          break;
        case 'string':
          bytes += obj.length * 2;
          break;
        case 'boolean':
          bytes += 4;
          break;
        case 'object':
          var objClass = Object.prototype.toString.call(obj).slice(8, -1);
          if (objClass === 'Object' || objClass === 'Array') {
            for (var key in obj) {
              if (!obj.hasOwnProperty(key)) continue;
              sizeOf(obj[key]);
            }
          } else bytes += obj.toString().length * 2;
          break;
      }
    }
    return bytes;
  }

  function formatByteSize(bytes) {
    if (bytes < 1024) return bytes + ' bytes';
    else if (bytes < 1048576) return (bytes / 1024).toFixed(3) + ' KiB';
    else if (bytes < 1073741824) return (bytes / 1048576).toFixed(3) + ' MiB';
    else return (bytes / 1073741824).toFixed(3) + ' GiB';
  }

  return formatByteSize(sizeOf(obj));
}
